module.exports = __webpack_public_path__ + "static/media/xiuguluanshan_package.79637e06.webp";